module.exports = __webpack_public_path__ + "img/cards-min.fa49696b.png";